import { render, staticRenderFns } from "./ProviderDetails.vue?vue&type=template&id=4fadbb80&scoped=true"
import script from "./ProviderDetails.vue?vue&type=script&lang=js"
export * from "./ProviderDetails.vue?vue&type=script&lang=js"
import style0 from "./ProviderDetails.vue?vue&type=style&index=0&id=4fadbb80&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fadbb80",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/ProviderDetails.vue
// module id = 2464
// module chunks = 31